import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkPagingPrevButton, UitkPagingNextButton } from 'uitk-react-button';
import styles from '../uitk-calendar.css';

// Modules
var getClassNameList = classNames.bind(styles);
var UitkCalendarNavigationControls = function (_a) {
  var canAdvance = _a.canAdvance,
    canRetreat = _a.canRetreat,
    children = _a.children,
    className = _a.className,
    enabled = _a.enabled,
    navType = _a.navType,
    _b = _a.numMonths,
    numMonths = _b === void 0 ? 0 : _b,
    _c = _a.stretchy,
    stretchy = _c === void 0 ? false : _c,
    handleNextClicked = _a.handleNextClicked,
    handlePrevClicked = _a.handlePrevClicked;
  var isInset = navType === 'inset';
  var rootClasses = getClassNameList({
    'uitk-cal-controls': true,
    'uitk-cal-controls-stretchy': stretchy,
    className: className
  });
  var l10n = useLocalization();
  var parentClasses = getClassNameList({
    'uitk-cal-controls-parent-inset-single': isInset && numMonths === 1,
    'uitk-cal-controls-parent-outset-single': !isInset && numMonths === 1,
    'uitk-cal-controls-parent-outset-multi': !isInset && numMonths > 1,
    'uitk-cal-controls-parent-stretchy': stretchy
  });
  var buttonClasses = getClassNameList('uitk-cal-controls-button', {
    'uitk-cal-controls-button-inset': isInset && numMonths === 1,
    'uitk-cal-controls-button-inset-multi': isInset && numMonths > 1,
    'uitk-cal-controls-button-outset': !isInset
  });
  var prevButtonClasses = getClassNameList(buttonClasses, 'uitk-cal-controls-button-prev');
  var nextButtonClasses = getClassNameList(buttonClasses, 'uitk-cal-controls-button-next');
  var previousUID = Math.random().toString(36).substring(7);
  var nextUID = Math.random().toString(36).substring(7);
  if (enabled) {
    return React.createElement("div", {
      className: rootClasses
    }, React.createElement("div", {
      className: prevButtonClasses
    }, React.createElement(UitkPagingPrevButton, {
      "data-stid": "uitk-calendar-navigation-controls-previous-button",
      disabled: !canRetreat,
      iconId: previousUID,
      iconTitle: l10n.formatText('calendar.prevMonthButton.a11yLabel'),
      onClick: handlePrevClicked
    })), React.createElement("div", {
      className: nextButtonClasses
    }, React.createElement(UitkPagingNextButton, {
      "data-stid": "uitk-calendar-navigation-controls-next-button",
      disabled: !canAdvance,
      iconId: nextUID,
      iconTitle: l10n.formatText('calendar.nextMonthButton.a11yLabel'),
      onClick: handleNextClicked
    })), React.createElement("div", {
      className: parentClasses
    }, children));
  }
  var childrenClassNames = getClassNameList(className, 'uitk-cal-controls-empty');
  UitkCalendarNavigationControls.displayName = 'UitkCalendarNavigationControls';
  return React.createElement("div", {
    className: childrenClassNames
  }, children);
};
export { UitkCalendarNavigationControls };